import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login/login.component';
import { RegistryComponent } from './registry/registry.component';
import {
  RecaptchaModule,
  RecaptchaV3Module,
  RECAPTCHA_V3_SITE_KEY,
} from 'ng-recaptcha';
import { UtilModule } from '../util/util.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { DetalleComponent } from './detalle/detalle.component';
import { CambiarContraseniaComponent } from './cambiar-contrasenia/cambiar-contrasenia.component';
import { ModalRestablecerContraseniaComponent } from './modal-restablecer-contrasenia/modal-restablecer-contrasenia.component';
import { RestablecerContraseniaComponent } from './restablecer-contrasenia/restablecer-contrasenia.component';

import { ModalDobleFactorComponent } from './modal-doble-factor/modal-doble-factor.component';
import { ModalTipoUsuarioComponent } from './modal-tipo-usuario/modal-tipo-usuario.component';
import { ValidarUsuarioComponent } from './validar-usuario/validar-usuario.component';
import { CalendarModule } from 'primeng/calendar';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalTerminosComponent } from './modal-terminos/modal-terminos.component';
import { LoginAdminComponent } from './login-admin/login-admin.component';
import { AutenticacionDigitalComponent } from './autenticacion-digital/autenticacion-digital.component';
import { RegistroEmpresaComponent } from './registro-empresa/registro-empresa.component';
import { PasosSeguirComponent } from './pasos-seguir/pasos-seguir.component';
import { CredencialesDatosAdicionalesEmpresaComponent } from './credenciales-datos-adicionales-empresa/credenciales-datos-adicionales-empresa.component';
import { RestablecerContraseniaEmpresaComponent } from './restablecer-contrasenia-empresa/restablecer-contrasenia-empresa.component';

@NgModule({
  declarations: [
    LoginComponent,
    RegistryComponent,
    DetalleComponent,
    CambiarContraseniaComponent,
    ModalRestablecerContraseniaComponent,
    RestablecerContraseniaComponent,
    ModalDobleFactorComponent,
    ModalTipoUsuarioComponent,
    ValidarUsuarioComponent,
    ModalTerminosComponent,
    LoginAdminComponent,
    AutenticacionDigitalComponent,
    RegistroEmpresaComponent,
    PasosSeguirComponent,
    CredencialesDatosAdicionalesEmpresaComponent,
    RestablecerContraseniaEmpresaComponent
  ],
  imports: [
    CommonModule,
    RecaptchaModule,
    RecaptchaV3Module,
    RouterModule,
    UtilModule,
    ReactiveFormsModule,
    CalendarModule,
    TranslatePipe,
    FormsModule,
  ],
  exports: [
    LoginComponent,
    RegistryComponent,
    DetalleComponent,
    CambiarContraseniaComponent,
    ModalRestablecerContraseniaComponent,
    RestablecerContraseniaComponent,
    ModalDobleFactorComponent,
    ModalTipoUsuarioComponent,
    ValidarUsuarioComponent,
  ],
  providers: [
    {
      provide: RECAPTCHA_V3_SITE_KEY,
      useValue: '6Le1bSMqAAAAAL0xVqhR0GzE_FsqhzNDeAlljbbs',
    },
  ],
})
export class AuthModule {}
